import { useEffect, useState } from "react";

import apiClient from "../../../services/apiClient";
import NotificationManagementPage from "../../notification/components/NotificationManagementPage";
import { TemplateCard } from "./ParentTelegramPage";
import "./ParentTelegramPage.css";

// 학원 관리 > 알림 관리(2026-09-30). 학부모 알림을 알림톡 모드와 텔레그램 모드 중 하나로 고른다.
// 알림톡 모드면 원래 알림톡 관리 화면을, 텔레그램 모드면 텔레그램 문구 화면을 보인다.
// 텔레그램 모드에서는 과제 알림과 알림장(지류 과제)이 모두 알림톡 대신 텔레그램으로 간다.
// 서버: api/echo/parent_telegram.py (ParentNotificationChannel, ParentTelegramTemplate)
const NotificationModePage = () => {
  const [data, setData] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [message, setMessage] = useState("");

  const apply = (next) => {
    setData(next);
    setTemplateList(next.template_list || []);
  };

  useEffect(() => {
    apiClient.get("/api/v1/echo/teacher/parent-telegram", { withAuth: true }).then((response) => apply(response.data));
  }, []);

  if (!data) return null;

  const studentList = data.student_list || [];
  const waitingCount = studentList.filter((one) => !one.connected).length;
  const connectedCount = studentList.length - waitingCount;

  const changeChannel = async (channel) => {
    setMessage("");
    const response = await apiClient.put("/api/v1/echo/teacher/parent-telegram", { channel }, { withAuth: true });
    apply(response.data);
  };

  const save = async () => {
    setMessage("");
    try {
      const response = await apiClient.put(
        "/api/v1/echo/teacher/parent-telegram",
        { template_list: templateList.map(({ key, text, is_enabled }) => ({ key, text, is_enabled })) },
        { withAuth: true }
      );
      apply(response.data);
      setMessage("저장했어요. 다음 알림부터 이 문구로 나가요.");
    } catch (caught) {
      setMessage(caught.response?.data?.error || "저장하지 못했어요.");
    }
  };

  const isTelegram = data.channel === "telegram";

  return (
    <div>
      <div className="parent-tg parent-tg--flush">
        <div className="section-title">알림 관리</div>
        <div className="parent-tg__modes parent-tg__modes--top">
          <button type="button" aria-pressed={!isTelegram} onClick={() => changeChannel("alimtalk")}>
            <b>💬 알림톡 모드</b>
            <span>카카오 알림톡으로 보내요. 건당 비용이 들고 문구는 카카오 심사를 받아야 해요.</span>
          </button>
          <button type="button" aria-pressed={isTelegram} onClick={() => changeChannel("telegram")}>
            <b>📲 텔레그램 모드</b>
            <span>과제 알림과 알림장을 알림톡 대신 텔레그램으로 보내요. 무료, 문구는 바로 고치고, 복습 소식까지 보내요.</span>
          </button>
        </div>
        {isTelegram && (
          <p className={waitingCount ? "parent-tg__warn" : "parent-tg__help"}>
            학부모 {studentList.length}집 중 {connectedCount}집이 텔레그램을 연결했어요.
            {waitingCount ? ` 아직 안 한 ${waitingCount}집은 알림을 받지 못해요. 학원 관리 > 텔레그램 · 출결에서 연결 링크를 보내 주세요.` : ""}
          </p>
        )}
      </div>

      {isTelegram ? (
        <div className="parent-tg">
          <section className="parent-tg__card">
            <div className="parent-tg__card-title">텔레그램 알림 문구</div>
            <p className="parent-tg__help">
              쓰던 알림톡 문구를 바탕으로 넣어 두었어요. 그대로 두거나 고쳐 쓰세요. <b>{"{학생명}"}</b> 같은 자리는 보낼 때 실제 값으로 바뀌고,
              아래 칸을 누르면 글 쓰던 자리에 들어가요. 알림장(지류 과제)은 알림톡 관리에 쓴 알림장 문구 그대로 텔레그램으로 가요.
            </p>
            {templateList.map((template, index) => (
              <TemplateCard
                key={template.key}
                template={template}
                variableList={data.variable_list || []}
                onChange={(patch) => setTemplateList((prev) => prev.map((one, i) => (i === index ? { ...one, ...patch } : one)))}
              />
            ))}
            <div className="parent-tg__save">
              {message && <span className="parent-tg__message">{message}</span>}
              <button type="button" className="parent-tg__primary" onClick={save}>저장하기</button>
            </div>
          </section>
        </div>
      ) : (
        <NotificationManagementPage />
      )}
    </div>
  );
};

export default NotificationModePage;
